import { useEffect } from "react";
import { Button, Modal, Form, message } from "antd";

export default function DeleteFirm({
  selected,
  isVisible,
  setDeleteModal,
}: any) {
  const [form] = Form.useForm();

  useEffect(() => {}, [selected]);

  const onSubmit = async () => {
    message.error("Sorry, you can't delete company");
    setDeleteModal(false);
  };

  const hideModal = async () => {
    setDeleteModal(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Delete Company"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteFirm"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form id="deleteFirm" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center font-bold">
            Are you sure you want to delete this company
            <span className="text-red-500 ml-1">{selected?.name}</span>
          </p>
        </div>
      </Form>
    </Modal>
  );
}
